import { useMediaQuery } from 'react-responsive';
import { BREAKPOINTS } from '@/constants/breakpoints';

interface DeviceDetectionResult {
  /** Below TABLET (< 1100px) */
  isMobile: boolean;
  /** TABLET to LAPTOP-1 (1100–1279px) */
  isTablet: boolean;
  /** SIDEBAR_DOCK and above (>= 1100px) — sidebar is an in-flow column, not a drawer */
  isSidebarDocked: boolean;
  /** HAT-1170: below PHONE (< 768px). Inside the mobile world, the narrowest tier. */
  isPhone: boolean;
  /** HAT-1170: TABLET_LARGE to TABLET-1 (960–1099px). iPad Pro 12.9", tablets in landscape. */
  isTabletLarge: boolean;
}

const useDeviceDetection = (): DeviceDetectionResult => {
  const isMobile = useMediaQuery({ maxWidth: BREAKPOINTS.TABLET - 1 });
  const isTablet = useMediaQuery({ minWidth: BREAKPOINTS.TABLET, maxWidth: BREAKPOINTS.LAPTOP - 1 });
  const isSidebarDocked = useMediaQuery({ minWidth: BREAKPOINTS.SIDEBAR_DOCK });
  const isPhone = useMediaQuery({ maxWidth: BREAKPOINTS.PHONE - 1 });
  const isTabletLarge = useMediaQuery({ minWidth: BREAKPOINTS.TABLET_LARGE, maxWidth: BREAKPOINTS.TABLET - 1 });

  return { isMobile, isTablet, isSidebarDocked, isPhone, isTabletLarge };
};

export default useDeviceDetection;
